<template>
  <Col
    class="bg-tenant/20 w-16 rounded-sm py-3 sm:h-24 sm:w-20 sm:rounded-xl sm:py-4"
    items="center"
    justify="center"
  >
    <span class="text-base font-semibold sm:text-xl">{{
      activityStartDay
    }}</span>

    <span class="text-base font-semibold sm:text-xl">{{
      activityStartMonthShort
    }}</span>
  </Col>
</template>

<script setup lang="ts">
import { IPublicActivityRegistrationLinkDTO } from "lib/eduConfigurationServiceClient";
import { computed } from "vue";

const props = defineProps<{
  link: IPublicActivityRegistrationLinkDTO;
}>();

const activityStartDay = computed(() => props.link.startDateTime.day);

const activityStartMonthShort = computed(
  () => props.link.startDateTime.monthShort?.toUpperCase(), // Sometimes short month ends with a dot, so we remove it
);
</script>
